import _ from 'lodash';

const {
  REACT_APP_SERVER_GRAPHQL,
  REACT_APP_KK_REALM,
  REACT_APP_KK_RESOURCE,
  REACT_APP_KK_SSL_STATE,
  REACT_APP_KK_SERVER_URL,
  REACT_APP_KK_CLIENT_TYPE,
  REACT_APP_KK_CONFIDENTIAL_PORT,
  REACT_APP_SENTRY_DSN,
  REACT_APP_PROD_STATE,
  REACT_APP_REPORT_SERVICE,
  REACT_APP_BASENAME,
  CKEDITOR_URL,
} = process.env;

export default {
  keycloak: {
    realm: REACT_APP_KK_REALM,
    clientId: REACT_APP_KK_RESOURCE,
    resource: REACT_APP_KK_RESOURCE,
    'ssl-required': REACT_APP_KK_SSL_STATE,
    'public-client': _.defaultTo(REACT_APP_KK_CLIENT_TYPE, true) === true,
    url: REACT_APP_KK_SERVER_URL,
    'confidential-port': _.toInteger(REACT_APP_KK_CONFIDENTIAL_PORT),
  },
  api: {
    url: REACT_APP_SERVER_GRAPHQL,
  },
  sentry: {
    dsn: REACT_APP_SENTRY_DSN,
    state: REACT_APP_PROD_STATE,
    activated: REACT_APP_REPORT_SERVICE,
  },
  routes: {
    login: '/',
    main: '/',
    tramites: '/tramites',
    default: '/main',
  },
  basename: _.defaultTo(REACT_APP_BASENAME, '/'),
  ckeditor: _.defaultTo(
    CKEDITOR_URL,
    'https://cdn.jusneuquen.gov.ar/packages/ckeditor/ckeditor.js'
  ),
};
